module.exports = {"id":"201956","name":"Salif Sané","rating":"80","photo":"./data/images/photos/3/201956.png","club":{"name":"Hanovre 96","logo":"./data/images/clubs/Hanovre96.png"},"positions":["DC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SalifSane0.json
// module id = 3776
// module chunks = 0